import React, { useState } from 'react';
import '../nvbr/Dropdown.css';


function DropdownIki() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  
  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu clicked' : 'dropdown-menu'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <a
                className={item.cName}
                href={item.path}
                onClick={() => setClick(false)}
              >
                {item.title}
              </a>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownIki;


export const MenuItems =[
    {
        title:'Ekibimiz',
        path:'/hakkımızda/ekibimiz',
        cName:'dropdown-link',
    },
    {
        title:'Tarihçemiz',
        path:'/hakkımızda/tarihimiz',
        cName:'dropdown-link',
    },
    {
        title:'Hedefimiz',
        path:'/hakkımızda/hedefimiz',
        cName:'dropdown-link',
    },
    
]